import { COLORS as C, RADIUS } from "../../constants/ui";

/**
 * A loading placeholder shaped like the thing it stands in for.
 *
 * Preferred over a centred spinner wherever the final layout is predictable:
 * the page keeps its shape while data arrives, so nothing jumps when it lands.
 *
 * The sweep keyframe and its reduced-motion opt-out live in index.css — a
 * stylesheet is the only place a keyframe can be declared, and this app
 * otherwise styles with inline objects.
 */
export default function Skeleton({
  width = "100%",
  height = 16,
  radius = 6,
  style,
  ...rest
}) {
  return (
    <span
      className="ts-skeleton"
      aria-hidden="true"
      style={{
        display: "block",
        width,
        height,
        borderRadius: radius,
        background: C.sunken,
        backgroundImage: `linear-gradient(90deg, ${C.sunken} 0%, ${C.lineSoft} 50%, ${C.sunken} 100%)`,
        backgroundSize: "200% 100%",
        animation: "skeletonSweep 1.4s ease-in-out infinite",
        ...style,
      }}
      {...rest}
    />
  );
}

/**
 * A list of card-shaped rows — the common case for "a list is loading".
 * `aria-busy` on the wrapper is what a screen reader announces; the blocks
 * themselves are decorative and hidden.
 */
export function SkeletonList({ rows = 4, height = 64, gap = 10, label = "Loading" }) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label={label}
      style={{ display: "flex", flexDirection: "column", gap }}
    >
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={height} radius={RADIUS.card} />
      ))}
    </div>
  );
}
